import { Component, OnInit } from '@angular/core';
import { RegisterService } from 'src/app/core/services/register/register.service';
import { BusinessResponseDTO } from 'src/app/shared/models/dtos/register-form/business-response-dto/business-response-dto';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-invite-refuse',
  templateUrl: './invite-refuse.page.html',
})
/**
 * Page that a representative is redirected to upon refusing an invitation
 */
export class InviteRefusePage implements OnInit {
  RoutesKeys = RoutesKeys;
  currentBusiness!: BusinessResponseDTO;

  /**
   * @constructor
   */
  constructor(private readonly registerService: RegisterService) {}

  /**
   * on init
   */
  ngOnInit() {
    this.currentBusiness = this.registerService.inviteCurrentBusiness!;
  }
}
